<template>
  <div
    v-if="title || backgroundImageUrl"
    :style="backgroundImageStyle"
    class="header-container d-flex"
    :class="contentStyle"
  >
    <div class="title w-50 w-xl-100" :class="contentStyle">
      <prismic-rich-text
        v-if="title"
        :field="title"
        :style="titleStyle"
        :class="mapSizeToClass(titleSize)"
      ></prismic-rich-text>
      <prismic-rich-text
        v-if="subtitle"
        class="mt-3"
        :class="mapSizeToClass(subtitleSize)"
        :style="titleStyle"
        :field="subtitle"
      ></prismic-rich-text>
      <div v-if="buttonText && buttonPath" class="w-100 mt-2 mt-xl-5 d-flex" :class="contentStyle">
        <Button
          :to="path"
          :blank="blank"
          :with-gradient="!!buttonBackground"
          :gradient="buttonBackground"
          :font-color="buttonTextColor"
          :size="buttonSize"
          @click="showModal"
        >
          {{ buttonText }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from 'UI/Button';
import { mapGetters } from 'vuex';

export default {
  components: {
    Button
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      buttonBlank: false,
      buttonPath: '',
      buttonText: '',
      buttonBackground: '',
      buttonTextColor: '',
      contentAlign: '',
      imageAlt: '',
      backgroundImageUrl: '',
      openModal: false,
      subtitle: '',
      title: '',
      titleColor: '',
      height: 'default',
      mobileBackgroundImageUrl: ''
    };
  },
  computed: {
    ...mapGetters('experience', ['getExperienceColor']),
    blank() {
      return !this.openModal ? this.buttonBlank : false;
    },
    contentStyle() {
      let contentClasses = '';

      if (this.contentAlign === 'left') {
        contentClasses = 'text-left align-items-center justify-content-start';
      } else if (this.contentAlign === 'right') {
        contentClasses = 'text-right align-items-center justify-content-end';
      } else {
        contentClasses = 'text-center align-items-center justify-content-center';
      }

      return contentClasses;
    },
    path() {
      return !this.openModal ? this.buttonPath : '';
    },
    titleStyle() {
      return { color: this.titleColor };
    },
    headerHeight() {
      let height = '350px';
      if (this.height == '50% screen') {
        height = '50vh';
      } else if (this.height == '80% screen') {
        height = '80vh';
      } else if (this.height == '100% screen') {
        height = '100vh';
      }
      return height;
    },
    backgroundImageStyle() {
      const style = {
        '--header-height': this.headerHeight
      };
      if (this.backgroundImageUrl) {
        style['--background-img'] = `url(${this.backgroundImageUrl})`;
        style['background-size'] = 'cover';
        style['--mobile-img'] = `url(${this.mobileBackgroundImageUrl || this.backgroundImageUrl})`;
      }
      return style;
    }
  },
  created() {
    const { primary } = this.slice;

    this.buttonBlank = primary.button_blank;
    this.buttonPath = primary.button_path[0]?.text;
    this.buttonText = primary.button_text[0]?.text;
    this.contentAlign = primary.content_align ? primary.content_align : '';
    this.imageAlt = primary.image.alt;
    this.backgroundImageUrl = primary.image.url;
    this.mobileBackgroundImageUrl = primary.mobile_background_image?.url;
    this.openModal = primary.open_modal;
    this.subtitle = primary.subtitle;
    this.title = primary.title1[0]?.text ? primary.title1 : '';
    this.titleColor = primary.title_color ? primary.title_color : 'black';
    this.buttonBackground = primary.button_background_color
      ? primary.button_background_color
      : this.getExperienceColor;
    this.buttonTextColor = primary.button_text_color ? primary.button_text_color : '#fff';
    this.height = this.slice.primary.height;
    this.titleSize = this.slice.primary.title_size;
    this.subtitleSize = this.slice.primary.subtitle_size;
    this.buttonSize = this.slice.primary.button_size;
  },
  methods: {
    showModal() {
      if (this.openModal) {
        this.$bvModal.show(this.buttonPath);
      }
    },
    mapSizeToClass(size) {
      const className = ['h4', 'h3', 'h2', 'h1'];
      const sizeName = ['small', 'small-medium', 'medium', 'big'];
      const indexOf = sizeName.indexOf(size);
      return className[indexOf] || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.header-container {
  position: relative;
  overflow: hidden;
  height: var(--header-height);
  min-height: 350px;
  padding: 0px;
  background-size: cover;
  background-position: center center;
  margin-left: -15px;
  margin-right: -15px;
  background-image: var(--background-img);
  @include xl {
    height: auto;
    width: auto;
  }
  @include sm {
    background-image: var(--mobile-img);
    padding: 20px 0;
    background-size: cover;
    background-repeat: no-repeat;
  }
}
.title {
  z-index: 1;
  padding: 30px;
  @include lg {
    padding: 10px;
  }
}
.w-xl-100 {
  @include xl {
    width: 100% !important;
  }
}
</style>
